import 'chartjs-adapter-date-fns';
import { useStyletron } from 'baseui';
import { TimeSeriesLineChart } from '../../../features/Charts/LineCharts/TimeSeriesLineChart';

export type EfficiencyChartProps = {
    id: string,
    resourceGroupId: string,
    value: number | boolean,
    stepped: boolean,
    showAverage?: boolean
}

const EfficiencyChart = (props: EfficiencyChartProps) => {
    const [css, theme] = useStyletron();
    const color = theme.colors.warning600;

    return <TimeSeriesLineChart
        lines={[
            { yScaleId: 'y', 
            fill: true, 
            stepped: true, 
            label: "Efficiency", 
            lineColor: color, 
            objectId: props.id, resourceGroupId: props.resourceGroupId, 
            propertyName: 'actEfficiency', 
            currentValue: props.value, 
            grace: 0 }
        ]}
        summarizeBy='1h'
        timespan={7 * 24 * 60}
    ></TimeSeriesLineChart>

};

export default EfficiencyChart;